export default __webpack_public_path__ + "static/centre-99f90fb40c4411b6f735b6a73265a5d7.png";